import React from 'react';
import "../styles/Quote.css";

const Quote = () => {
  return (
    <section id="quote" className="quote-section section">
      <h2>Get a Free Quote for Your Translation</h2>
      <p className="subtitle">
        Need Professional Translation Services? Trust PTS for Fast, Accurate, and Certified Results!
      </p>

      <footer id="contact" className="contact-footer">
        <h3>Contact Us Now!</h3>
        <p>
          <a href="mailto:service@perfect-translation-services.com">
            service@perfect-translation-services.com
          </a>
        </p>
        <p>
          <a href="https://wa.me/923020958948" target="_blank" rel="noopener noreferrer">
            WhatsApp: 0302 0958948
          </a>
        </p>
      </footer>
    </section>
  );
};

export default Quote;
